import React from "react";
import { Button, ButtonGroup } from "../../../components/ui";

/**
 * Save / Send footer shared by the sell flow's document sections
 * (Consignment Agreement, Purchasing Agreement, Purchase Order).
 *
 * Save records the step and moves on; Send emails the document first, so it is
 * the row's primary and is disabled (label "Sending...") while that request runs.
 * `feature` names the data-btn ids: `<feature>-save` / `<feature>-confirm-send`.
 */
export function AgreementFooter({ feature, onSave, onSend, sending = false, className = "" }) {
  return (
    <ButtonGroup align="end" className={className}>
      <Button variant="secondary" data-btn={`${feature}-save`} onClick={onSave}>
        Save
      </Button>
      <Button variant="primary" data-btn={`${feature}-confirm-send`} onClick={onSend} disabled={sending}>
        {sending ? "Sending..." : "Send"}
      </Button>
    </ButtonGroup>
  );
}

export default AgreementFooter;
